{
    "rapormusteri": {
        "Baslik": "Klantrapportage",
        "Musteri": "Klant",
        "Referans": "Referentie",
        "Kullanici": "Gebruiker",
        "Cep": "Telefoon",
        "Cep2": "Telefoon 2",
        "Randevu": "Afspraak",
        "SatisOnayli": "Goedgekeurde Verkoop",
        "SatisOnaysiz": "Niet-goedgekeurde Verkoop",
        "SatisIptal": "Geannuleerde Verkoop",
        "SatisCayma": "Ingetrokken Verkoop",
        "Arama": "Zoeken",
        "Ara": "Zoeken",
        "Kapat": "Sluiten",
        "Temizle": "Wissen",
        "BaslangicTarihi": "Lid Sinds",
        "BitisTarihi": "Lid Tot",
        "Islemler": "Acties",
        "Duzenle": "Bewerken",
        "Sil": "Verwijderen",
        "Ad": "Voornaam",
        "Soyad": "Achternaam",
        "Cinsiyet": "Geslacht",
        "KimlikNo": "ID-nummer",
        "Email": "E-mail",
        "Email2": "E-mail 2",
        "Adres": "Adres",
        "Aciklama": "Beschrijving",
        "Guncelle": "Update",
        "EminMisiniz": "Weet u het zeker?",
        "GeriAlamazsiniz": "U kunt deze actie niet ongedaan maken!",
        "EvetSil": "Ja, verwijderen!",
        "Iptal": "Annuleren",
        "ExcelAktar": "Exporteren naar Excel",
        "MusteriDetay": "Klantdetail",
        "Bilgisi": "Informatie",
        "Aktarma": "Overdracht",
        "GeciciYetki": "Tijdelijke Bevoegdheid",
        "Durum": "Status",
        "Kilit": "Vergrendelen",
        "Meslek": "Beroep",
        "DogumTarihi": "Geboortedatum",
        "HedefKullanici": "Doelgebruiker",
        "Aktar": "Transfer",
        "YetkiVerilecekKullanici": "Doelgebruiker",
        "YetkiVer": "Bevoegdheid Geven",
        "VerilenYetkiler": "Gegeven Bevoegdheden",
        "KayitBulunamadi": "Geen records gevonden.",
        "Il": "Provincie",
        "Ilce": "District",
        "Olusturma": "Aanmaak",
        "SonGuncelleme": "Laatste Update",
        "TasimaAciklama": "Alle gegevens van de geselecteerde klant worden overgedragen naar de doelklant en de huidige klant wordt verwijderd.",
        "HedefMusteri": "Doelklant",
        "Tasi": "Verplaatsen",
        "MevcutMusteriKodu": "Huidige Klantcode",
        "Onsekizalti": "Onder 18",
        "SigortaEttiren": "Verzekeringnemer"
    }
}
